import React from "react";
import { Box, type IconProps, Icon } from "@chakra-ui/react";

export function CheckIcon(props: IconProps) {
  return (
    <Icon
      boxSize="11px"
      color="product.forest.600"
      viewBox="0 0 12 10"
      fill="none"
      strokeWidth="2px"
      stroke="currentColor"
      strokeDasharray="16"
      {...props}
    >
      <Box as="polyline" points="1.5 6 4.5 9 10.5 1" />
    </Icon>
  );
}
